import '../../css/app.css'
import '../../css/main.css'
import '../../css/common.css'
import '../../css/payment.css'
import Page from '../../Page';
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { BRAND_LOGO } from '../../../config/brand';

const LOADING_LOGOS = {
    baekma: "/img/wh_logo_white.png",
    onu: BRAND_LOGO,
};

function LoadingModal() {
    const logo = process.env.REACT_APP_LOGO || LOADING_LOGOS[process.env.REACT_APP_HOST_BRAND] || "/img/dl_logo_white.png";
    return (
        <div className="pay_loading_wrap" >
            <div className="pay_loading">
                <img src={logo} alt="loading" style={{ width: "200px" }} />
            </div>
        </div>
    )
}

function MessageModal({ message }) {
    const [messageModal, setMessageModal] = useState(false)

    useEffect(() => {
        if (message.msg) {
            setMessageModal(true)
        }
    }, [message]);

    
    useEffect(() => {
        if (!messageModal) return;
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                setMessageModal(false);
            }
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [messageModal]);

    return (
        <>
            {
                messageModal
                    ?
                    <div id="alert_modal" className="modal alert_modal" tabindex="-1" >
                        <div className="modal-dialog">
                            <h2 className="text-center font-bold text-lg pt-5">{message?.msg ?? ""}</h2>
                            <div className="modal-footer">
                                <button type="button" id="alert_ok_btn" className="btn w-20 btn_ok" onClick={() => setMessageModal(false)}>확인</button>
                            </div>
                        </div>
                    </div>
                    :
                    ""
            }
        </>
    )
}

export { LoadingModal, MessageModal }
